import {
    SET_ADD_ACCOUNT_TEXT,
    SET_ADD_ACCOUNT_TOOLTIP_TEXT,
    SET_PLAY_TEXT,
    SET_PLAY_TOOLTIP_TEXT,
    SET_PIN_TOOLTIP_TEXT,
    SET_UNPIN_TOOLTIP_TEXT,
    SET_START_CLIENT_TOOLTIP_TEXT,
    SET_STOP_CLIENT_TOOLTIP_TEXT,
    SET_PROFILE_TOOLTIP_TEXT,
    SET_LOGOUT_TOOLTIP_TEXT,
    SET_ERROR_AUTO_REFRESH_TEXT,
    SET_ERROR_REFRESHING_TEXT,
    SET_TEXTS,
} from './constants'

export function setAddAccountText(text) {
    return {
        type: SET_ADD_ACCOUNT_TEXT,
        payload: text,
    }
}

export function setAddAccountTooltipText(text) {
    return {
        type: SET_ADD_ACCOUNT_TOOLTIP_TEXT,
        payload: text,
    }
}

export function setPlayText(text) {
    return {
        type: SET_PLAY_TEXT,
        payload: text,
    }
}

export function setPlayTooltipText(text) {
    return {
        type: SET_PLAY_TOOLTIP_TEXT,
        payload: text,
    }
}

export function setPinTooltipText(text) {
    return {
        type: SET_PIN_TOOLTIP_TEXT,
        payload: text,
    }
}

export function setUnPinTooltipText(text) {
    return {
        type: SET_UNPIN_TOOLTIP_TEXT,
        payload: text,
    }
}

export function setStartTooltipText(text) {
    return {
        type: SET_START_CLIENT_TOOLTIP_TEXT,
        payload: text,
    }
}

export function setStopTooltipText(text) {
    return {
        type: SET_STOP_CLIENT_TOOLTIP_TEXT,
        payload: text,
    }
}

export function setProfileTooltipText(text) {
    return {
        type: SET_PROFILE_TOOLTIP_TEXT,
        payload: text,
    }
}

export function setLogOutTooltipText(text) {
    return {
        type: SET_LOGOUT_TOOLTIP_TEXT,
        payload: text,
    }
}

export function setErrorAutoRefreshText(text) {
    return {
        type: SET_ERROR_AUTO_REFRESH_TEXT,
        payload: text,
    }
}

export function setErrorRefreshingText(text) {
    return {
        type: SET_ERROR_REFRESHING_TEXT,
        payload: text,
    }
}

export function setTexts(texts) {
    return {
        type: SET_TEXTS,
        payload: texts,
    }
}



// WEBPACK FOOTER //
// ./src/features/Users/data/texts/actions.js